import { Header } from "./display/Header.js";
import { Menu } from "./display/Menu.js";
import { Navigation } from "./display/Navigation.js";
import { Offline } from "./display/Offline.js";
import { SettingsWindow } from "./display/SettingsWindow.js";
import { Share } from "./display/Share.js";
import { ErrorView } from "./model/ErrorView.js";
import { Language } from "./model/Language.js";

export class Base {

    constructor() {
        e5.console.log("[eventfive.awi.polarstern-v2]", "[Base]");

        this.init();
    }

    private async init() {
        new e5.FocusVisible();
        new e5.Tooltip();

        e5.Debug.add({
            uid: "show-labels",
            icon: "fal fa-text",
            cookie: true,
            tooltip: "Show Label keys"
        });

        //Fix addressbar overlays on content in landscape orientation.
        //Apple again: https://medium.com/@susiekim9/how-to-compensate-for-the-ios-viewport-unit-bug-46e78d54af0d
        // if (e5.Caps.isIOS) {
        //     var w = 0;
        //     e5.Player.onTick.add(() => {
        //         if (w != window.innerHeight) {
        //             w = window.innerHeight;
        //             document.documentElement.classList.add("ios-fix-height");
        //             setTimeout(() => {
        //                 window.getComputedStyle(document.documentElement).width;
        //                 document.documentElement.classList.remove("ios-fix-height");
        //             });
        //         }
        //     });
        // }

        if (e5.Plugins.config.isDebugging) {
            window.errorView = new ErrorView();
        }

        window.lang = new Language();
        window.share = new Share().create({
            container: document.body,
            direction: "right"
        });
        window.offlineOverlay = new Offline().create({
            container: document.body
        });

        this.setupSettingsWindow();

        new Header({
            element: document.querySelector("#awi-header")
        });

        document.querySelectorAll(".awi-navigation").forEach((element) => {
            new Navigation().create({
                element: element as HTMLElement
            });
        });

        document.addEventListener("error", (e) => {
            var t: HTMLElement = e.target as any;
            if (t && t.tagName.toLowerCase() == "img") {
                t.classList.add("awi-base__image-failed");
            }
        }, true);

        e5.event.on(document.body, "click", `[data-action="togglelanguage"]`, (e) => {
            lang.current = lang.current === "de" ? "en" : "de";
        });

        e5.event.on({
            scope: document.body,
            type: "click",
            selector: `a[href^="http"]`,
            passive: false,
            listener: (e) => {
                var t = e.target as HTMLAnchorElement;
                var a = new RegExp('/' + window.location.host + '/');
                if (!a.test(t.href)
                    && (!t.target || t.target == "_self")) {
                    e.event.preventDefault();
                    window.open(t.href, '_blank');
                    console.warn("Found link to external page that does not open in a new tab!");
                }
            }
        })
    }

    private async setupSettingsWindow() {
        if (!(e5.Plugins.notification?.supported
            && e5.Plugins.notification?.enabled)) {
            return;
        }

        var menu = new Menu().create({
            element: document.querySelector("#awi-header")
        });

        var btn = menu.addButton({
            icon: "fal fa-bell",
            position: "end",
            ariaLabel: {
                de: "Push-Benachrichtigungen",
                en: "Push notifications"
            },
        });
        btn.element.setAttribute("aria-controls", "settings-window");
        btn.element.setAttribute("data-action", "openmenu");
        btn.element.setAttribute("aria-expanded", "false");

        new SettingsWindow().create({
            container: document.body,
            direction: "right"
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Base();
});